<app-shared-dialog
  [title]="'mfa_enrolment_prompt.title' | translate"
  [options]="{
    size: 'medium',
    hideActions: true,
    hideCloseButton: !skippable
  }"
  (cancel)="close()"
>
  <div class="prompt" data-testid="mfa-enrolment-prompt">
    <ng-container *ngIf="enrolled; else setup">
      <p class="prompt__lede" data-testid="mfa-enrolment-prompt-done">
        {{ 'mfa_enrolment_prompt.done' | translate }}
      </p>

      <div class="prompt__actions">
        <ui-button
          type="primary"
          testId="mfa-enrolment-prompt-close"
          [label]="'mfa_enrolment_prompt.continue' | translate"
          (click)="close()"
        ></ui-button>
      </div>
    </ng-container>

    <ng-template #setup>
      <p class="prompt__lede">{{ 'mfa_enrolment_prompt.lede' | translate }}</p>

      <p class="prompt__notice" *ngIf="deadline" data-testid="mfa-enrolment-prompt-deadline">
        {{
          'mfa_enrolment_prompt.deadline'
            | translate: { date: deadline | date: 'short' }
        }}
      </p>

      <!-- Required and out of grace: the policy moved under a live session,
           since a login in that state is refused outright. -->
      <p class="prompt__notice" *ngIf="!skippable" data-testid="mfa-enrolment-prompt-blocking">
        {{ 'mfa_enrolment_prompt.required_now' | translate }}
      </p>

      <ng-container *ngIf="method === null; else wizard">
        <div class="prompt__actions">
          <ui-button
            type="primary"
            testId="mfa-enrolment-prompt-totp"
            [label]="'settings_security.set_up_authenticator' | translate"
            (click)="choose('totp')"
          ></ui-button>

          <!-- The server refuses the enrolment where Email OTP is off. -->
          <ui-button
            *ngIf="emailAvailable"
            type="secondary"
            testId="mfa-enrolment-prompt-email"
            [label]="'settings_security.set_up_email' | translate"
            (click)="choose('email')"
          ></ui-button>

          <button
            *ngIf="skippable"
            type="button"
            class="prompt__link"
            data-testid="mfa-enrolment-prompt-skip"
            (click)="close()"
          >
            {{ 'mfa_enrolment_prompt.skip' | translate }}
          </button>

          <!-- The only way out when there is no skip: this dialog has no ×
               either, and an enrolment that keeps failing would otherwise
               leave nothing but a page reload. -->
          <button
            *ngIf="!skippable"
            type="button"
            class="prompt__link"
            data-testid="mfa-enrolment-prompt-logout"
            (click)="logout()"
          >
            {{ 'authentication.logout' | translate }}
          </button>
        </div>
      </ng-container>

      <ng-template #wizard>
        <app-mfa-enrolment-wizard
          [method]="method!"
          (enrolled)="onEnrolled()"
          (cancelled)="onCancelled()"
        ></app-mfa-enrolment-wizard>
      </ng-template>
    </ng-template>
  </div>
</app-shared-dialog>
